<div class="row">
    <div class="col-md-12">
        <nb-card>
            <nb-card-header>{{'tytul.materialy' | translate}}</nb-card-header>
            <nb-card-body>
                <div class="container">
                    <div *ngFor="let material of dane" class="card">
                        <div class="card-horizontal bg-light text-dark m-2 d-flex d-flex-row">
                            <div class="d-flex justify-content-center" style="height: 200px; width: 200px; overflow: hidden;">
                                <img src="{{ material.urlOkladki }}" class="img-square-wrapper" style="height: 100%;">
                            </div>
                            <div class="card-body" style="width:100%;">
                                <div class="d-flex justify-content-between">
                                    <h4 class="card-title">{{ material.nazwa }}</h4>
                                    <a class="align-self-start" nbButton size="small" href="{{ material.urlPliku }}">{{ 'akcja.pobierz' | translate }}</a>
                                </div>
                                <p class="card-text">{{ material.opis }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </nb-card-body>
        </nb-card>
    </div>
</div>